import { getAccessToken } from "../Services/authToken";

export interface PairingPanel {
  interview_pairing_id: string;
  requisition_id: string;
  candidate_full_name: string;
  interviewer_1_name?: string | null;
  interviewer_2_name?: string | null;
  interviewer_3_name?: string | null;
  interviewer_4_name?: string | null;
  interviewer_5_name?: string | null;
  interview_number: number;
  total_interviews: string;
  start_time: string;
  end_time: string;
  interviewer_1_id?: string | null;
  interview_1_start_time?: string | null;
  interview_1_end_time?: string | null;
  interview_1_duration?: number | null;
  interviewer_2_id?: string | null;
  interview_2_start_time?: string | null;
  interview_2_end_time?: string | null;
  interview_2_duration?: number | null;
  interviewer_3_id?: string | null;
  interview_3_start_time?: string | null;
  interview_3_end_time?: string | null;
  interview_3_duration?: number | null;
  interviewer_4_id?: string | null;
  interview_4_start_time?: string | null;
  interview_4_end_time?: string | null;
  interview_4_duration?: number | null;
  interviewer_5_id?: string | null;
  interview_5_start_time?: string | null;
  interview_5_end_time?: string | null;
  interview_5_duration?: number | null;
  slot_available: boolean;
  recruiter_email: string;
  recruiter_name: string;
  interview_structure?: string;
  interview_1_type?: string | null;
  interview_2_type?: string | null;
  interview_3_type?: string | null;
  interview_4_type?: string | null;
  interview_5_type?: string | null;
  submission_group_id: string;
  stage: number;
  is_assigned: boolean;
  meeting_link?: string | null;
  slot_booking_id?: string | null;
}

export interface InterviewPairingsResponsePanel {
  requisition_id: string;
  job_title: string;
  interview_paired: boolean;
  pairings: PairingPanel[];
}

const hostname = window.location.hostname;

const getBaseUrl = (): string => {
  if (hostname.includes('localhost')) return 'http://localhost:8080';
  if (hostname.includes('dev')) return 'https://candidateinterviewscheduler-dev.pwc.com';
  if (hostname.includes('stg') || hostname.includes('stage')) return 'https://candidateinterviewscheduler-stg.pwc.com';
  return 'https://candidateinterviewscheduler.pwc.com';
};

export const getInterviewPairingsPanel = async (
  rescheduleClicked: boolean = false
): Promise<InterviewPairingsResponsePanel | null> => {
  try {
    const token = await getAccessToken();
    if (!token) {
      console.error('No authentication token available');
      return null;
    }

    const baseurl = getBaseUrl();
    const url = `${baseurl}/api/candidate-dashboard/interview-pairings-panel?reschedulePage=${rescheduleClicked}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`Failed: ${res.status} ${res.statusText}`);
    }

    const raw = await res.json();
    console.log('[API] Fetched panel interview pairings raw:', raw);

    // API returns an array — extract the first element
    const data: InterviewPairingsResponsePanel = Array.isArray(raw) ? raw[0] : raw;

    if (!data || !data.pairings) {
      console.warn('[API] Panel pairings response is empty or malformed');
      return null;
    }

    console.log('[API] Fetched panel interview pairings:', data);
    return data;
  } catch (err) {
    console.error('Error fetching panel interview pairings:', err);
    return null;
  }
};